import React,{Fragment, Component,useState, useEffect} from 'react'; 
import {Link} from 'react-router-dom';
import WOW from 'wowjs';
import Masonry from 'react-masonry-component';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';

//images
import banner1 from './../../../images/banner/banner1.png';
import banner2 from './../../../images/banner/banner2.jpeg';
import banner3 from './../../../images/banner/bnr3.jpg';
import banner from './../../../images/banner/banner.jpeg';
import ban1 from './../../../images/banner/ban1.jpeg';
import ban2 from './../../../images/banner/ban2.jpeg';
import main1 from './../../../images/gallery/main1.jpg';
import main2 from './../../../images/gallery/main2.jpg';
import main3 from './../../../images/gallery/main3.jpg';
import main4 from './../../../images/gallery/main4.jpg';
import main5 from './../../../images/gallery/main5.jpg';
import main6 from './../../../images/gallery/main6.jpg';
import port1 from './../../../images/portfolio/portfolio-box/pic1.jpg';
import port2 from './../../../images/portfolio/portfolio-box/pic2.jpg';
import port3 from './../../../images/portfolio/portfolio-box/pic3.jpg';
import port4 from './../../../images/portfolio/portfolio-box/pic4.jpg';
import port5 from './../../../images/portfolio/portfolio-box/pic5.jpg';
import port6 from './../../../images/portfolio/portfolio-box/pic6.jpg';

const imageBlog = [
	{  
		Large_img: banner1, 
		tag: ['Residential', 'Completed'], 
		title: 'Goldcrest Tower A',
		date: 'Delivered in 2022',
		description: 'Fully completed residential tower with premium living features and state-of-the-art amenities.'
	},
	{  
		Large_img: banner2, 
		tag: ['Residential', 'Completed'], 
		title: 'Goldcrest Tower B',
		date: 'Delivered in 2022',
		description: 'Completed residential tower offering various apartment layouts in a prime location.'
	},
	{  
		Large_img: banner3, 
		tag: ['Residential', 'Ongoing'], 
		title: 'Goldcrest Dreams Tower C',
		date: 'Under Construction',
		description: 'Modern residential development focusing on innovation and sustainable design.'
	},
	{  
		Large_img: ban1, 
		tag: ['Residential', 'Upcoming'], 
		title: 'Goldcrest Dreams Tower D',
		date: 'Coming Soon',
		description: 'New development featuring comfortable and luxurious living spaces with modern amenities.'
	},
	{  
		Large_img: banner, 
		tag: ['Residential', 'Completed'], 
		title: 'Goldcrest Views',
		date: 'Delivered in 2022',
		description: '24-floor Residential Tower in JLT, Dubai with panoramic views and luxurious living.'
	},
	{  
		Large_img: ban2, 
		tag: ['Residential', 'Completed'], 
		title: 'Goldcrest View 2',
		date: 'Delivered in 2022',
		description: 'Prime address in Tower B, JLT, Dubai with outstanding architectural design.'
	},
	{  
		Large_img: main1, 
		tag: ['Commercial', 'Completed'], 
		title: 'Goldcrest Executive',
		date: 'Delivered in 2023',
		description: 'Premium commercial spaces in Jumeira Lake Towers designed for success and growth.'
	},
	{  
		Large_img: main2, 
		tag: ['Commercial', 'Ongoing'], 
		title: 'Goldcrest Business Center',
		date: 'Under Construction',
		description: 'Modern commercial development offering premium office spaces and retail units.'
	},
	{  
		Large_img: main3, 
		tag: ['Residential', 'Ongoing'], 
		title: 'Goldcrest Dreams Tower A',
		date: 'Under Construction',
		description: 'Luxury residential tower in Emirates City, Ajman with world-class amenities.'
	},
	{  
		Large_img: main4, 
		tag: ['Residential', 'Ongoing'], 
		title: 'Goldcrest Dreams Tower B',
		date: 'Under Construction',
		description: 'Contemporary living spaces in Emirates City, Ajman focusing on innovation.'
	},
	{  
		Large_img: main5, 
		tag: ['Commercial', 'Upcoming'], 
		title: 'Goldcrest Plaza',
		date: 'Coming Soon',
		description: 'New commercial development featuring retail and office spaces in prime location.'
	},
	{  
		Large_img: main6, 
		tag: ['Residential', 'Upcoming'], 
		title: 'Goldcrest Residences',
		date: 'Coming Soon',
		description: 'Upcoming residential project redefining urban living with sustainable design.'
	},
]

// Masonry section
const masonryOptions = {                                          
    transitionDuration: 0
};

const imagesLoadedOptions = { background: '.my-bg-image-el' }
// Masonry section end





const TagLi = ({name, handlesettag, tagActive}) => {                                                               
	return ( 
			
		<li className={` tag ${tagActive ? 'btn active' : 'btn'}` } onClick={() => handlesettag(name)} >
			<input type="radio" />
			<Link to={"#"} className="site-button-secondry button-skew" >	<span>{name} {''}</span> </Link>
		</li> 
	);
};

class Portfolio2 extends Component{
	componentDidMount(){
		new WOW.WOW().init();	
	}
	render(){
		return(
			<Fragment>	
			<Header />
			<div className="page-content bg-white">
				{/*  banner  */}
				<PageTitle motherMenu="Portfolio" activeMenu="Our Projects" />
				{/*  Section-1 Start  */}
				<PortfolioItem />
				
			</div>	
			<FooterPremium />
			</Fragment>			
		)
	}
} 

function PortfolioItem(){
	const [tag, setTag] = useState('All');
	const [filteredImages, setFilterdImages] = useState([]);
	
	useEffect( () => {
		tag === 'All' ? setFilterdImages(imageBlog) : setFilterdImages(imageBlog.filter( image => image.tag.includes(tag)))
	}, [tag])	
	
	return(
		<>
			<section className="content-inner-2" data-content="PORTFOLIO">				
				<div className="container">
					<div className="section-head text-center">
						<p>VIEW PORTFOLIO</p>
						<h2 className="title m-b10">Our Best Projects</h2>
						<p style={{fontSize: '16px', color: '#666', maxWidth: '700px', margin: '20px auto 0'}}>
							Explore Star Giga's portfolio of exceptional residential and commercial developments across the UAE. From completed projects to upcoming developments, discover spaces designed for modern living and business success.
						</p>
					</div>
					<div className="row">
						<div className="col-lg-12 text-center">
							<div className="site-filters filter-style1 clearfix m-b20">
								<ul className="filters" data-toggle="buttons">
									<TagLi name="All"  handlesettag={setTag} tagActive={ tag === 'All' ? true : false }	/>
									<TagLi name="Residential"  handlesettag={setTag} tagActive={ tag === 'Residential' ? true : false }	/>
									<TagLi name="Commercial" handlesettag={setTag} tagActive={ tag === 'Commercial' ? true : false }	 />
									<TagLi name="Completed"  handlesettag={setTag} tagActive={ tag === 'Completed' ? true : false }	/>
									<TagLi name="Ongoing"  handlesettag={setTag} tagActive={ tag === 'Ongoing' ? true : false }	/>
									<TagLi name="Upcoming"  handlesettag={setTag} tagActive={ tag === 'Upcoming' ? true : false }	/>
								</ul>
							</div>
						</div>
					</div>	
				</div>
				<div className="clearfix">
					<ul className="gallery mfp-gallery text-center portfolio-bx p-l0 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
						<Masonry
							className={'my-gallery-class'} // default ''
							options={masonryOptions} // default {}
							disableImagesLoaded={false} // default false
							updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
							imagesLoadedOptions={imagesLoadedOptions} // default {}
						>
							{filteredImages.map((item, index)=>(	
								
								<li data-category="abstract" className="card-container col-lg-3 col-md-4 col-sm-6 p-lr0 abstract" key={index}>
									<div className="dlab-media dlab-img-overlay1 dlab-img-effect portbox1" style={{height: '350px', overflow: 'hidden'}}>
										<img 
											src={item.Large_img} 
											alt={item.title}
											style={{
												width: '100%',
												height: '100%',
												objectFit: 'cover',
												display: 'block'
											}}
										/>
										<div className="overlay-bx">
											<div className="portinner">
												<span>{item.date}</span>
												<h3 className="port-title"><Link to={"/project-detail-1"}>{item.title}</Link></h3>
												<p style={{color: '#fff', fontSize: '14px', marginBottom: '15px', lineHeight: '1.6'}}>{item.description}</p>
												<Link 
													to={"/project-detail-1"} 
													className="btn btn-primary m-t15"
													style={{
														backgroundColor: '#b8975f',
														border: 'none',
														padding: '10px 25px',
														borderRadius: '5px',
														color: '#fff',
														fontWeight: '600',
														textDecoration: 'none',
														display: 'inline-block',
														transition: 'all 0.3s ease'
													}}
													onMouseEnter={(e) => e.target.style.backgroundColor = '#b8975f'}
													onMouseLeave={(e) => e.target.style.backgroundColor = '#b8975f'}
												>
													View Project
												</Link>
											</div>
										</div>
									</div>
								</li>
							))}	
						</Masonry>	
					</ul>
				</div>	
			</section>
		</>
	);
}

export default Portfolio2;